export default __webpack_public_path__ + "static/sarah-headshot-d8e08c4214d522eae5b096c0010eebc0.webp";